import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../resources/requestInfo";

import { confirmPhoneChangeRoutes } from "./routes";

export interface IConfirmPhoneChangeData {
  phone: string;
  code: number | string;
}

export interface IConfirmPhoneChangeResponse {
  success: boolean;
  message: string;
}

export const fetchConfirmPhoneChange = createAsyncThunk<IConfirmPhoneChangeResponse, IConfirmPhoneChangeData>(
  "confirmPhoneChange/fetchConfirmPhoneChange",
  async (data, { rejectWithValue }) => {
    try {
      const code = typeof data.code === 'string' ? parseInt(data.code, 10) : data.code;

      const requestData = {
        phone: data.phone,
        code: code
      };

      const response = await axiosInstance.post(confirmPhoneChangeRoutes.CONFIRM_PHONE, requestData);
      return response.data;
    } catch (error: any) {
      console.log("error fetchConfirmPhoneChange >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка подтверждения смены телефона");
    }
  }
);
